import React, { useState } from "react";

function About() {
    const [tab, setTab] = useState('Languages')

  return (
    <div className="bg-blue-500 p-12 text-center flex flex-col justify-center items-center" style={{ minHeight: 'calc(100vh - 64px)' }}>
        
        <div className="bg-blue-500 p-12 text-center flex flex-col justify-center items-center" style={{ minHeight: 'calc(100vh - 64px)' }}>
            <h1 className="text-white text-4xl font-bold mb-4">About Me</h1>
            <p className="text-white text-lg mb-4">I am a web developer who loves to code</p>
        </div>

        <h1 className="text-white text-4xl font-bold mb-4">Skills</h1>
        <p className="text-white text-lg mb-4">Here are some of my skills</p>

        <div className="flex justify-center font-bold">
            <button onClick={() => setTab('Languages')} className={`px-4 py-2 m-2 transition-colors duration-200 ${tab === 'Languages' ? 'bg-white text-blue-500' : 'text-white'}`}>Languages</button>
            <button onClick={() => setTab('Frameworks')} className={`px-4 py-2 m-2 transition-colors duration-200 ${tab === 'Frameworks' ? 'bg-white text-blue-500' : 'text-white'}`}>Frameworks</button>
            <button onClick={() => setTab('Tools')} className={`px-4 py-2 m-2 transition-colors duration-200 ${tab === 'Tools' ? 'bg-white text-blue-500' : 'text-white'}`}>Tools</button>
        </div>

        {tab === 'Languages' && (
            <ul className="flex justify-center flex-wrap font-bold">
                <div className="border-2 border-white text-white py-4 px-8 flex flex-col items-center space-y-2 transform transition-all ease-in-out duration-700 hover:scale-110 m-2">
                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg" alt="PHP" className="w-12 h-12" />
                    <span className="mt-2">PHP</span>
                </div>
                <div className="border-2 border-white text-white py-4 px-8 flex flex-col items-center space-y-2 transform transition-all ease-in-out duration-700 hover:scale-110 m-2">
                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" alt="JS" className="w-12 h-12" />
                    <span className="mt-2">JavaScript</span>
                </div>
            </ul>
        )}

        {tab === 'Frameworks' && (
            <ul className="flex justify-center flex-wrap font-bold">
                <div className="border-2 border-white text-white py-4 px-8 flex flex-col items-center space-y-2 transform transition-all ease-in-out duration-700 hover:scale-110 m-2">
                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg" alt="TailwindCSS" className="w-12 h-12 mr-4"/>
                    <span className="mt-2">TailwindCSS</span>
                </div>
                
                <div className="border-2 border-white text-white py-4 px-8 flex flex-col items-center space-y-2 transform transition-all ease-in-out duration-700 hover:scale-110 m-2">
                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/alpinejs/alpinejs-original.svg" alt="AlpineJS" className="w-12 h-12 mr-4"/>
                    <span className="mt-2">AlpineJS</span>
                </div>
            
                <div className="border-2 border-white text-white py-4 px-8 flex flex-col items-center space-y-2 transform transition-all ease-in-out duration-700 hover:scale-110 m-2">
                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/laravel/laravel-original.svg" alt="Laravel" className="w-12 h-12 mr-4"/>
                    <span className="mt-2">Laravel</span>
                </div>

                <div className="border-2 border-white text-white py-4 px-8 flex flex-col items-center space-y-2 transform transition-all ease-in-out duration-700 hover:scale-110 m-2">
                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/livewire/livewire-original.svg" alt="Livewire" className="w-12 h-12 mr-4"/>
                    <span className="mt-2">Livewire</span>
                </div>

                <div className="border-2 border-white text-white py-4 px-8 flex flex-col items-center space-y-2 transform transition-all ease-in-out duration-700 hover:scale-110 m-2">
                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" alt="NodeJS" className="w-12 h-12 mr-4"/>
                    <span className="mt-2">NodeJS</span>
                </div>
            </ul>
        )}

        {tab === 'Tools' && (
            <ul className="flex justify-center flex-wrap font-bold">
                <div className="border-2 border-white text-white py-4 px-8 flex flex-col items-center space-y-2 transform transition-all ease-in-out duration-700 hover:scale-110 m-2">
                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg" alt="Git" className="w-12 h-12 mr-4"/>
                    <span className="mt-2">Git</span>
                </div>

                <div className="border-2 border-white text-white py-4 px-8 flex flex-col items-center space-y-2 transform transition-all ease-in-out duration-700 hover:scale-110 m-2">
                    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postman/postman-original.svg" alt="Postman" className="w-12 h-12 mr-4"/>
                    <span className="mt-2">Postman</span>
                </div>
            </ul>
        )}
       
    </div>
  );
}

export default About;